import { useEffect, useState } from 'react';

import { useIntl } from 'react-intl';
import { useNotification } from '@atlassian/ui-modifications-core/controllers/issue-adjustments/use-notification';
import { notificationTypeToNotificationProperties } from './constants';

export const useUiModificationsNotifications = () => {
	const notification = useNotification();
	const { formatMessage } = useIntl();
	const [notificationProperties, setNotificationProperties] = useState<{
		message: string;
		type: 'warning' | 'information';
	} | null>(null);

	useEffect(() => {
		if (!notification) {
			setNotificationProperties(null);
		} else {
			const properties = notificationTypeToNotificationProperties[notification.type];
			const formattedMessage = formatMessage(properties.message);
			setNotificationProperties({ message: formattedMessage, type: properties.type });
		}
	}, [notification, formatMessage]);

	return notificationProperties ? [notificationProperties] : [null];
};
